import React, { Component } from "react";
//import "assets/css/safexpay-web.css"
import "./Spform.css";
import axios from "axios";
import Spinner from "reactstrap/lib/Spinner";
import ReCAPTCHA from "react-google-recaptcha";
// import ReCaptcha from "components/Registration/ReCaptcha";
import { generateCaptcha } from "../../assets/utils/constFuntion";
class Spform extends Component {
  state = {
    name: "",
    emailid: "",
    mobilenumber: "",
    description: "",
    firstNameError: false,
    emailError: false,
    mobileNumberError: false,
    descError: false,
    isLoaded: false,
    genCaptcha: "",
    captcha: "",
    isInvalidCaptcha: false,
    token: "",
  };

  flag = 0;
  datasend = false;
  componentDidMount() {
    this.generateNewCaptcha();
  }
  generateNewCaptcha = () => {
    const genCaptcha = generateCaptcha();
    this.setState({ genCaptcha });
  };
  postdatahandler = (e) => {
    e.preventDefault();

    // if (this.state.captcha === this.state.genCaptcha) {
    //   this.setState({ isInvalidCaptcha: false });
    // } else {
    //   this.setState({ isInvalidCaptcha: true });
    //   return false;
    // }
    if (!this.handleFullName()) {
      return false;
    }
    if (!this.handleEmail()) {
      return false;
    }
    if (!this.handleMobileNumber()) {
      return false;
    }
    if (!this.handleDescription()) {
      return false;
    }
    // var emailid = this.state.emailid;
    // var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    // console.log("====>>>>>>>", pattern.test(emailid));
    // var validemail = pattern.test(emailid);

    // var name = this.state.name;
    // var patternm = /^[a-zA-Z][\sa-zA-Z]*/;
    // var validname = patternm.test(name);
    // var patternmm = /^[A-Za-z0-9 ]+$/;
    // var validnamee = patternmm.test(name);

    // var description = this.state.description;
    // var validdes = patternm.test(description);
    // var validdesp = patternmm.test(description);

    if (
      this.state.name == "" ||
      this.state.mobilenumber == "" ||
      this.state.emailid == "" ||
      this.state.description == ""
    ) {
      this.datasend = false;
    } else {
      this.datasend = true;
    }

    const data = {
      full_name: this.state.name,
      email_id: this.state.emailid,
      mobile_no: this.state.mobilenumber,
      form_type: "Support",
      description: this.state.description,
      token: this.state.token,
    };

    if (this.datasend) {
      // console.log("data", data);
      this.flag = 1;
      this.setState({ isLoaded: true });
      // document.getElementById("submitform").innerHTML = "Loading.....";

      axios
        .post(
          "https://www.avantgardepayments.com/agadmin/api/emailSender/post",
          data
        )
        .then((response) => {
          //https://
          // console.log(response);
          this.datasend = false;
          this.setState({ isLoaded: false });
          if (response.data.message == "Success") {
            // document.getElementById("submitform").style.backgroundColor =
            //   "var(--darkgreen)";
            // document.getElementById("submitform").innerHTML = "Send";
            document.getElementById("confmsg2").style.visibility = "visible";
          }
          if (response.data.message == "Success") {
            document.getElementById("txtFirstName").value = "";
            document.getElementById("txtEmail").value = "";
            document.getElementById("txtMobile").value = "";
            document.getElementById("txtTextarea").value = "";
            this.setState({
              name: "",
              emailid: "",
              mobilenumber: "",
              description: "",
              captcha: "",
            });
            window.location.href = "/";
          }
          if (response.data.message == "Success") {
            setTimeout(() => {
              // document.getElementById("submitform").style.backgroundColor =
              //   "var(--blue)";
              // document.getElementById("submitform").innerHTML =
              //   "Submit a ticket";
              document.getElementById("confmsg2").style.visibility = "hidden";
            }, 4000);
          }
        });
    }
  };

  handleEmail = () => {
    var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    console.log("email", pattern.test(this.state.emailid));
    if (pattern.test(this.state.emailid) && this.state.emailid.length < 65) {
      let sp = this.state.emailid.split("@")[1].split(".");
      if (sp.length > 3) {
        document.getElementById("txtEmail").classList.add("is-invalid");
        this.setState({ emailError: true });
        return false;
      } else {
        document.getElementById("txtEmail").classList.remove("is-invalid");
        this.setState({ emailError: false });
        return true;
      }
    } else {
      document.getElementById("txtEmail").classList.add("is-invalid");
      this.setState({ emailError: true });
      return false;
    }
  };
  handleFullName = () => {
    let reg = /^[a-zA-Z\-_.'\s]{1,50}$/;
    if (!reg.test(this.state.name)) {
      this.setState({ firstNameError: true });
      document.getElementById("txtFirstName").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ firstNameError: false });
      document.getElementById("txtFirstName").classList.remove("is-invalid");
      return true;
    }
  };
  handleMobileNumber = () => {
    if (this.state.mobilenumber.length > 20 || !this.state.mobilenumber) {
      this.setState({ mobileNumberError: true });
      document.getElementById("txtMobile").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ mobileNumberError: false });
      document.getElementById("txtMobile").classList.remove("is-invalid");
      return true;
    }
  };

  handleDescription = () => {
    if (!this.state.description.trim()) {
      this.setState({ descError: true });
      document.getElementById("txtTextarea").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ firstNameError: false });
      document.getElementById("txtTextarea").classList.remove("is-invalid");
      return true;
    }
  };
  handleCaptchaOnChange = (value) => {
    console.log("Captcha value:", value);
    this.setState({ token: value });
  };
  render() {
    var attchedClasses = ["dv-Registration-content", "Open"];
    if (this.props.open) attchedClasses = ["dv-Registration-content", "Open"];

    return (
      <>
        <div className="blueback"></div>

        <section className={attchedClasses.join(" ")}>
          <form>
            <div className="dv-registration-form dv-form pt-5">
              <div className="form-group">
                <div className="sphd">
                  <div className="section-heading sphd1">
                    How can we support you today?
                  </div>
                </div>
                <label htmlFor="txtFirstName">
                  Name <span className="req">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-options"
                  id="txtFirstName"
                  placeholder="Enter Name"
                  onChange={(event) =>
                    this.setState({ name: event.target.value })
                  }
                  onBlur={this.handleFullName}
                />
                {this.state.firstNameError && (
                  <small style={{ color: "red" }}>Invalid name.</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="txtEmail">
                  Email Address <span className="req">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-options"
                  id="txtEmail"
                  placeholder="Enter Email Address"
                  onChange={(event) =>
                    this.setState({ emailid: event.target.value })
                  }
                  onBlur={this.handleEmail}
                />
                {this.state.emailError && (
                  <small style={{ color: "red" }}>Invalid email address.</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="txtMobile">
                  Mobile Number <span className="req">*</span>
                </label>
                <input
                  type="number"
                  className="form-control form-options"
                  id="txtMobile"
                  placeholder="Enter Mobile Number"
                  onChange={(event) =>
                    this.setState({ mobilenumber: event.target.value })
                  }
                  onBlur={this.handleMobileNumber}
                />
                {this.state.mobileNumberError && (
                  <small style={{ color: "red" }}>Invalid mobile number.</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="txtFirstName">
                  Description <span className="req">*</span>
                </label>
                <textarea
                  type="text"
                  className="form-control form-options"
                  id="txtTextarea"
                  placeholder="How can we assist you? Explain your query in brief."
                  onChange={(event) =>
                    this.setState({ description: event.target.value })
                  }
                  onBlur={this.handleDescription}
                />
                {this.state.descError && (
                  <small style={{ color: "red" }}>Invalid description.</small>
                )}
              </div>
              <h6
                className="confmsg2"
                id="confmsg2"
                style={{ marginBottom: "1rem" }}
              >
                Thank you, your message has been sent successfully.
              </h6>
              <div className="dv-captcha__center">
                <div className="gen-captcha">
                  <ReCAPTCHA
                    sitekey="6Lc7UdQcAAAAAGodQYkrOJ_M9MvEaliWMCRN7hsv"
                    onChange={this.handleCaptchaOnChange}
                  />
                </div>
                {/* <div className="form-group" style={{ width:"100%" }}>
                  <input
                    placeholder="Enter Captcha Value"
                    className="form-control"
                    id="user_captcha_input"
                    name="user_captcha_input"
                    type="text"
                    value={this.state.captcha}
                    onChange={(e) =>
                      this.setState({ captcha: e.target.value })
                    }
                    autoComplete="off"
                  />
                </div> */}
                {this.state.isInvalidCaptcha && (
                  <small className="err">*Invalid captcha</small>
                )}
              </div>
              <div className="text-center">
                <button
                  className="submitbtn"
                  id="submitform"
                  onClick={(event) => this.postdatahandler(event)}
                  disabled={this.state.isLoaded}
                >
                  Submit
                  {this.state.isLoaded ? (
                    <Spinner
                      size="sm"
                      color="light"
                      className="btn-loader"
                      style={{ marginLeft: "0.8rem" }}
                    />
                  ) : null}
                </button>
              </div>
            </div>
          </form>
        </section>
      </>
    );
  }
}

export default Spform;
